"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAuctionRegistrationDto = instanceOfAuctionRegistrationDto;
exports.AuctionRegistrationDtoFromJSON = AuctionRegistrationDtoFromJSON;
exports.AuctionRegistrationDtoFromJSONTyped = AuctionRegistrationDtoFromJSONTyped;
exports.AuctionRegistrationDtoToJSON = AuctionRegistrationDtoToJSON;
exports.AuctionRegistrationDtoToJSONTyped = AuctionRegistrationDtoToJSONTyped;
/**
 * Check if a given object implements the AuctionRegistrationDto interface.
 */
function instanceOfAuctionRegistrationDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function AuctionRegistrationDtoFromJSON(json) {
    return AuctionRegistrationDtoFromJSONTyped(json, false);
}
function AuctionRegistrationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'userId': json['userId'],
        'listingId': json['listingId'],
        'createdAt': (new Date(json['createdAt'])),
    };
}
function AuctionRegistrationDtoToJSON(json) {
    return AuctionRegistrationDtoToJSONTyped(json, false);
}
function AuctionRegistrationDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'userId': value['userId'],
        'listingId': value['listingId'],
        'createdAt': value['createdAt'].toISOString(),
    };
}
